import { render, staticRenderFns } from "./PartnerSelfRegistration.vue?vue&type=template&id=2cf4e251&"
import script from "./PartnerSelfRegistration.vue?vue&type=script&lang=js&"
export * from "./PartnerSelfRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports